import { render } from "./OtherBadges.vue?vue&type=template&id=8a2fecd8&ts=true"
import script from "./OtherBadges.vue?vue&type=script&lang=ts"
export * from "./OtherBadges.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__